// vp-recurpay-enhanced.js (NO STICKY BAR)

(function(){

  const $  = (s,r=document)=>r.querySelector(s);

  const $$ = (s,r=document)=>Array.from(r.querySelectorAll(s));



  const rpPdp  = $('.recurpay-pdp-widget');

  const rpRoot = rpPdp ? $('[data-recurpay-widget]', rpPdp) : null;

  if (!rpRoot) return;



  // ---------------------- CONFIG ----------------------

  const CHECKLIST_ITEMS = [

    '30-Day Guarantee',

    'Cancel Anytime',

    'Auto-deliver on your schedule',

    'FREE 3–5 Day Shipping',

  ];

  const SYNC_PAGE_PRICE = false; // set true if you want PDP price to follow selection



  // ---------------------- HELPERS ----------------------

  const productPriceEl =

    $('[data-product-price]') || $('.price-item--regular') || $('.product__price');



  const getContainers = () => $$('.recurpay__widget_container', rpRoot);

  const getCon = (type) => getContainers().find(c => c.dataset.type === type) || null;



  const textFrom  = (c, sel) => (c && $(sel, c)) ? $(sel, c).textContent.trim() : '';

  const getMoney  = (c) => textFrom(c, '.recurpay__group_selling_price .money, .recurpay__group_selling_price');

  const getCompare= (c) => textFrom(c, '.recurpay__group_compare_price .money, .recurpay__group_compare_price');



  // Current containers

  let subCon = getCon('subscription-purchase');

  let oneCon = getCon('onetime-purchase');



  // Enforce order: Subscription before One-time (even after RP re-renders)

  function enforceOrder(){

    subCon = getCon('subscription-purchase');

    oneCon = getCon('onetime-purchase');

    if (!subCon || !oneCon) return;



    if (subCon.parentNode === oneCon.parentNode && subCon.nextElementSibling !== oneCon){

      subCon.parentNode.insertBefore(subCon, oneCon);

    }

    // Ensure divider sits right before one-time if it exists

    const divider = rpRoot.parentElement.querySelector('.vp-divider');

    if (divider && divider.nextElementSibling !== oneCon){

      oneCon.parentNode.insertBefore(divider, oneCon);

    }

  }



  // Initial prices

  let subPriceTxt   = getMoney(subCon);

  let subCompareTxt = getCompare(subCon);

  let onePriceTxt   = getMoney(oneCon);



  const valToNum = (txt) => {

    const n = parseFloat(String(txt||'').replace(/[^0-9.]/g,''));

    return isNaN(n) ? null : n;

  };

  const pct = (a,b)=> (a&&b) ? Math.round((1 - a/b) * 100) : null;

  let savePct = pct(valToNum(subPriceTxt), valToNum(subCompareTxt));



  // ---------------------- OFFER HEADER ----------------------

  const offer = document.createElement('div');

  offer.className = 'vp-offer';

  offer.innerHTML = `

    <div class="vp-offer__row">

      <div class="vp-offer__price" id="vpOfferPrice">${subPriceTxt || ''}</div>

      ${subCompareTxt ? `<div class="vp-offer__compare" id="vpOfferCompare">${subCompareTxt}</div>` : '<div id="vpOfferCompare" style="display:none"></div>'}

      ${savePct != null ? `<div class="vp-offer__badge" id="vpOfferBadge">SAVE ${savePct}% TODAY</div>` : '<div id="vpOfferBadge" style="display:none"></div>'}

    </div>

    <div class="vp-offer__subline" id="vpOfferSubline">Deliver every month · Cancel anytime</div>

  `;

  rpRoot.parentElement.insertBefore(offer, rpRoot);



  const freqSel = subCon ? $('.recurpay__frequency_select', subCon) : null;

  const setSubline = ()=>{

    let when = '';

    if (freqSel?.selectedOptions?.[0]){

      when = freqSel.selectedOptions[0].textContent.trim();

    }

    $('#vpOfferSubline').textContent = when

      ? `Deliver ${when.replace(/Subscription|\(|\)/gi,'').trim()} · Cancel anytime`

      : `Deliver every month · Cancel anytime`;

  };

  freqSel?.addEventListener('change', setSubline);

  setSubline();



  // ---------------------- SEGMENTED TOGGLE (above widget) ----------------------

  const seg = document.createElement('div');

  seg.className = 'vp-sub-toggle';

  seg.innerHTML = `

    <div class="vp-sub-toggle__option" data-type="subscription-purchase" aria-pressed="false">

      Subscribe &amp; Save

      ${subPriceTxt ? `<span class="vp-sub-toggle__price" id="vpSegSubPrice">${subPriceTxt}</span>` : `<span class="vp-sub-toggle__price" id="vpSegSubPrice"></span>`}

      ${savePct != null ? `<span class="vp-sub-toggle__save" id="vpSegSave">Save ${savePct}%</span>` : `<span class="vp-sub-toggle__save" id="vpSegSave" style="display:none"></span>`}

    </div>

    <div class="vp-sub-toggle__option" data-type="onetime-purchase" aria-pressed="false">

      One-Time

      ${onePriceTxt ? `<span class="vp-sub-toggle__price" id="vpSegOnePrice">${onePriceTxt}</span>` : `<span class="vp-sub-toggle__price" id="vpSegOnePrice"></span>`}

    </div>

  `;

  rpRoot.parentElement.insertBefore(seg, rpRoot);



  // Map to actual radios

  const rpRadios = {

    'subscription-purchase': subCon && $('.recurpay__group_input', subCon),

    'onetime-purchase':      oneCon && $('.recurpay__group_input', oneCon),

  };



  // Checklist under subscription CTA

  if (subCon){

    const afterCta = document.createElement('div');

    afterCta.className = 'vp-checklist';

    afterCta.innerHTML = CHECKLIST_ITEMS.map(t => `

      <div class="vp-checklist__item"><span class="vp-checklist__tick"></span><span>${t}</span></div>

    `).join('');

    const action = $('[data-recurpay-action]', subCon);

    action?.parentElement.appendChild(afterCta);

  }



  // One-time divider headline

  if (oneCon){

    const divider = document.createElement('div');

    divider.className = 'vp-divider';

    divider.innerHTML = `<span>ONE-TIME PURCHASE FOR ${onePriceTxt || ''}</span>`;

    oneCon.parentElement.insertBefore(divider, oneCon);

  }



  // Make RP CTA say “Get Started →”

  function setSubscribeCTA(){

    const btn = subCon ? $('[data-recurpay-action]', subCon) : null;

    if (btn) btn.textContent = 'Get Started →';

  }

  setSubscribeCTA();



  // ---------------------- STATE + SYNC ----------------------

  function readPrices(){

    subPriceTxt   = getMoney(subCon);

    subCompareTxt = getCompare(subCon);

    onePriceTxt   = getMoney(oneCon);

    savePct       = pct(valToNum(subPriceTxt), valToNum(subCompareTxt));

  }



  const syncUI = ()=>{

    enforceOrder();

    setSubscribeCTA();



    // Which RP container is active?

    const selected = getContainers().find(c => c.classList.contains('recurpay__widget_container--selected'));

    const type = selected ? selected.dataset.type : '';



    // Update segmented toggle "pressed" state

    $$('.vp-sub-toggle__option').forEach(btn=>{

      btn.setAttribute('aria-pressed', btn.dataset.type === type);

    });



    // Prices

    readPrices();



    // Offer header

    const offerPrice   = $('#vpOfferPrice'); if (offerPrice) offerPrice.textContent = subPriceTxt || '';

    const offerCompare = $('#vpOfferCompare');

    if (offerCompare){

      if (subCompareTxt){ offerCompare.style.display=''; offerCompare.textContent = subCompareTxt; }

      else { offerCompare.style.display='none'; }

    }

    const offerBadge = $('#vpOfferBadge');

    if (offerBadge){

      if (savePct != null){ offerBadge.style.display=''; offerBadge.textContent = `SAVE ${savePct}% TODAY`; }

      else { offerBadge.style.display='none'; }

    }



    // Segmented toggle prices

    const segSub = $('#vpSegSubPrice'); if (segSub) segSub.textContent = subPriceTxt || '';

    const segOne = $('#vpSegOnePrice'); if (segOne) segOne.textContent = onePriceTxt || '';

    const segSave= $('#vpSegSave');

    if (segSave){

      if (savePct != null){ segSave.style.display=''; segSave.textContent = `Save ${savePct}%`; }

      else { segSave.style.display='none'; }

    }



    // Update divider text

    const divider = $('.vp-divider span');

    if (divider) divider.textContent = `ONE-TIME PURCHASE FOR ${onePriceTxt || ''}`;



    // Optional: sync PDP price block

    if (SYNC_PAGE_PRICE && productPriceEl){

      productPriceEl.textContent = (type === 'subscription-purchase' ? (subPriceTxt || '') : (onePriceTxt || ''));

    }

  };



  // Click segmented toggle → click the real RP radios

  $$('.vp-sub-toggle__option').forEach(btn=>{

    btn.addEventListener('click', ()=>{

      const radio = btn.dataset.type === 'subscription-purchase'

        ? (subCon && $('.recurpay__group_input', subCon))

        : (oneCon && $('.recurpay__group_input', oneCon));

      radio?.click();

    });

  });



  // Listen for RP changes & frequency changes

  $$('.recurpay__group_input', rpRoot).forEach(r => r.addEventListener('change', syncUI));

  freqSel?.addEventListener('change', syncUI);



  // Observe RP re-renders (async) & text changes

  new MutationObserver(() => { syncUI(); })

    .observe(rpRoot, {subtree:true, attributes:true, attributeFilter:['class'], childList:true, characterData:true});



  // First paint

  enforceOrder();

  syncUI();



  // OPTIONAL: preselect Subscribe on load

  // subCon?.querySelector('.recurpay__group_input')?.click();

})();

